/*
 * Progressive enhancement for the two pages that browse a product grid — the
 * collection page and the search results page: the mobile filter toggle,
 * filter auto-submit, and "load more" fetch-and-append.
 *
 * None of it is required for either page to work. snippets/facets.liquid is a
 * plain GET <form>, and "Visa N fler produkter" is a plain <a> to the next
 * paginated page. This file only makes both nicer.
 *
 * (assets/collection.js until the search page needed the same three things,
 * 2026-08-02.)
 */
(function () {
  'use strict';

  function qs(selector, context) {
    return (context || document).querySelector(selector);
  }

  function qsa(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  /* sessionStorage kan kasta i privat läge eller med full kvot. Ett filter som
     glömmer sitt öppna läge är inte värt att fälla sidan för. */
  function readStore(key) {
    try {
      var raw = window.sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeStore(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      /* Se ovan. */
    }
  }

  /* --------------------------------------------------------------------
     Mobile filter panel
     -------------------------------------------------------------------- */

  /* Två ytor, ett formulär. Sorteringen och filtren är två olika ärenden och
     får varsin yta, men de delar GET-formulär — ett eget formulär för
     sorteringen hade tappat de aktiva filtren vid submit. `data-mode` avgör
     vilka grupper som syns; CSS:en gör resten.

     Panel-id skiljer sig per sida (snippets/facets.liquid tar det som
     parameter), så det läses ur knappens aria-controls i stället för att
     hårdkodas. */
  var openButtons = qsa('[data-filters-open]');
  var mobileQuery = window.matchMedia('(max-width: 900px)');
  var panel = null;

  if (openButtons.length) {
    var panelId = openButtons[0].getAttribute('aria-controls');
    panel = panelId ? document.getElementById(panelId) : null;
  }

  if (panel) {
    var lastOpener = null;
    var scrim = qs('.filters__scrim');

    var closePanel = function () {
      panel.classList.remove('is-open');
      panel.removeAttribute('data-mode');
      if (scrim) scrim.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
      /* Fokus tillbaka dit det kom ifrån — annars står tangentbordet på
         <body> längst upp i dokumentet efter en stängning. */
      if (lastOpener) lastOpener.focus();
      lastOpener = null;
    };

    openButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var mode = button.getAttribute('data-filters-open');
        if (panel.classList.contains('is-open') && panel.getAttribute('data-mode') === mode) {
          closePanel();
          return;
        }
        lastOpener = button;
        panel.setAttribute('data-mode', mode);
        panel.classList.add('is-open');
        if (scrim) scrim.classList.add('is-open');
        /* Sidan bakom ska inte skrolla med när överlägget är öppet. */
        document.documentElement.style.overflow = 'hidden';
        openButtons.forEach(function (other) {
          other.setAttribute('aria-expanded', String(other === button));
        });

        /* Vilken filtergrupp pillen gäller. Sorteringspillen har ingen. */
        var param = button.getAttribute('data-filter-param');

        /* Överlägget öppnar med grupperna hopfällda. Öppen ser besökaren en
           lång lista med varumärken och måste skrolla för att ens få veta
           vilka filterdimensioner som finns; hopfälld är första skärmen en
           innehållsförteckning — Varumärke, Egenskaper, Storlek — och valet
           blir vilket ärende man har.

           Undantaget är grupper som redan filtrerar. De öppnas, så att den
           som kommer tillbaka efter en tillämpning ser vad som är ikryssat i
           stället för att leta rätt på det. Markören är räknaren i rubriken,
           som Liquid bara renderar när gruppen har aktiva värden.

           Servern renderar samma utgångsläge sedan 2026-08-06 — hopfällt
           utom aktiva grupper, i sidokolumnen också. Raderna nedan står kvar
           ändå: panelen kan öppnas om utan sidladdning, och då är serverns
           `open` bara läget vid FÖRRA öppningen. */
        /* Sortläget visar bara sorteringsgruppen, och CSS:en döljer dess
           rubrik — panelen ska öppna direkt i alternativen. Gruppen renderas
           hopfälld (den är sidokolumnens översta rad på desktop), så den måste
           fällas ut här. Utan raden är sortöverlägget en tom yta. */
        var sortGroup = qs('.filters__group--sort', panel);
        if (sortGroup && mode === 'sort') sortGroup.open = true;

        if (mode === 'filter') {
          var target = null;
          var groups = qsa('.filters__group:not(.filters__group--sort)', panel);
          groups.forEach(function (group) {
            if (param && group.getAttribute('data-filter-param') === param) {
              /* Trycket gällde EN grupp: bara den fälls ut. Att öppna även de
                 andra aktiva hade skjutit ner den man faktiskt bad om. */
              group.open = true;
              target = group;
            } else if (param) {
              group.open = false;
            } else {
              group.open = !!qs('.filters__summary-count', group);
            }
          });

          /* Panelen kan ha skrollats av ett tidigare besök i den, och
             grupperna ovanför den valda kan vara många. Utan det här öppnar
             överlägget på fel höjd och ser tomt ut. */
          if (target) {
            panel.scrollTop = 0;
            var form = qs('.filters__form', panel);
            if (form) form.scrollTop = 0;
            target.scrollIntoView({ block: 'nearest' });
          }
        }

        var close = qs('[data-filters-close]', panel);
        if (close) close.focus();
      });
    });

    /* Både krysset i huvudet och scrimen bär data-filters-close, och scrimen
       ligger utanför panelen — därför dokumentet och inte panelen. */
    qsa('[data-filters-close]').forEach(function (button) {
      button.addEventListener('click', closePanel);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
    });

    /* Överlägget hör till mobilläget. Roteras telefonen till liggande, eller
       öppnas sidan i ett fönster som växer förbi 900 px, ska panelen tillbaka
       till sidokolumnen i stället för att ligga kvar över sidan.

       MediaQueryList fick addEventListener först i Safari 14 (2020). På äldre
       iOS kastade raden TypeError, och eftersom allt i den här filen ligger i
       samma IIFE tog den med sig auto-submit, sorteringsmenyn OCH "Visa fler"
       i fallet — hela sidans JavaScript, för en panel som byter läge. */
    var closeOnDesktop = function () {
      if (!mobileQuery.matches && panel.classList.contains('is-open')) closePanel();
    };

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', closeOnDesktop);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(closeOnDesktop);
    }
  }

  /* --------------------------------------------------------------------
     "Visa N fler" per filtergrupp
     --------------------------------------------------------------------

     Markup och trösklar ligger i snippets/facets.liquid; här är bara
     växlingen. Delegerat på dokumentet i stället för per knapp: samma
     snippet renderas på kategorisidan och söksidan, och grupperna byts ut
     helt när Section Rendering API:t ritar om resultatet.

     Läget växlar bara framåt och tillbaka i den här sidvisningen — en
     submit laddar om sidan och servern bestämmer utgångsläget igen. Det är
     avsiktligt: den enda utfällning som betyder något efter en tillämpning
     är den som bär ett ikryssat värde, och den renderas utfälld av Liquid. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-filters-more]');
    if (!button) return;

    var options = document.getElementById(button.getAttribute('aria-controls'));
    if (!options) return;

    var expanded = options.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded
      ? button.getAttribute('data-label-less')
      : button.getAttribute('data-label-more');

    /* Hopfällning kan dra bort rader ovanför knappen så att den hoppar uppåt
       under fingret. Rulla tillbaka gruppens rubrik i bild när den hamnat
       utanför — annars står man plötsligt i nästa grupp. */
    if (!expanded) {
      var group = button.closest('.filters__group');
      if (group && group.getBoundingClientRect().top < 0) {
        group.scrollIntoView({ block: 'nearest' });
      }
    }
  });

  /* --------------------------------------------------------------------
     "Läs mer" på kategoribeskrivningen

     CSS:en klipper texten till två rader (se `.collection__desc` i base.css);
     här avgörs bara OM knappen behövs, och växlingen.

     Knappen renderas dold och tänds först när texten faktiskt svämmar över.
     En "Läs mer" som fäller ut ingenting är värre än ingen knapp alls — den
     lovar innehåll som inte finns, och de flesta av butikens kollektioner har
     korta beskrivningar.

     Mätningen görs på det KLIPPTA elementet: `scrollHeight` är textens fulla
     höjd även när `overflow: hidden` döljer resten, så jämförelsen mot
     `clientHeight` svarar exakt på frågan "ryms den?". 2 px slack för
     subpixelavrundning, samma skäl som pilknapparnas 1 px längre ner.

     Om om vid resize: två rader vid 1700 px kan vara fyra vid 390 px, och
     tvärtom. Utfällt läge rörs inte av mätningen — den som öppnat texten ska
     inte få den hopfälld av att fönstret ändrar storlek. Webbtypsnitt kan
     dessutom byta bredd efter first paint, därav omsyncen på `load`.
     -------------------------------------------------------------------- */
  qsa('[data-clamp]').forEach(function (wrap) {
    var text = qs('[data-clamp-text]', wrap);
    var toggle = qs('[data-clamp-toggle]', wrap);
    if (!text || !toggle) return;

    function sync() {
      if (wrap.classList.contains('is-expanded')) return;
      toggle.classList.toggle('is-needed', text.scrollHeight - text.clientHeight > 2);
    }

    toggle.addEventListener('click', function () {
      var expanded = wrap.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded
        ? toggle.getAttribute('data-label-less')
        : toggle.getAttribute('data-label-more');

      /* Hopfällningen drar bort rader ovanför knappen så att den hoppar uppåt
         under fingret — samma sak som filtergruppernas "Visa färre" gör. */
      if (!expanded && wrap.getBoundingClientRect().top < 0) {
        wrap.scrollIntoView({ block: 'nearest' });
      }
    });

    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
    sync();
  });

  /* --------------------------------------------------------------------
     Auto-submit on filter/sort change — checkboxes and radios only.
     Price range stays explicit (the "Visa resultat" button), typing a
     price shouldn't fire a request per keystroke.

     Varje submit är en full sidladdning: filtren är riktiga GET-URL:er, och
     det är avsiktligt (se docs/DECISIONS.md). Priset är att grupperna faller
     tillbaka till serverns öppna/stängda läge och att fokus landar högst upp.
     Därav fördröjningen — den som kryssar tre rutor får en laddning i stället
     för tre — plus att öppna grupper och senast rörda ruta bärs över i
     sessionStorage. Utan JS submittar knappen "Visa resultat" som förut.
     -------------------------------------------------------------------- */

  var SUBMIT_DELAY = 600;
  var OPEN_GROUPS_KEY = 'hg-facets-open';
  var LAST_FIELD_KEY = 'hg-facets-field';

  var filtersForm = qs('.filters__form');
  if (filtersForm) {
    var submitTimer = null;

    var groupName = function (group) {
      var title = qs('.filters__summary-title', group);
      return title ? title.textContent.trim() : '';
    };

    /* Läget nycklas på sökvägen, inte globalt: ett filterklick byter bara
       query-strängen, medan en annan kategori har helt andra grupper — och
       skulle annars få allihop stängda av namn som inte matchar. */
    var saveGroups = function () {
      var open = qsa('.filters__group', filtersForm)
        .filter(function (group) {
          return group.open;
        })
        .map(groupName);
      writeStore(OPEN_GROUPS_KEY, { path: window.location.pathname, open: open });
    };

    var restoreGroups = function () {
      var state = readStore(OPEN_GROUPS_KEY);
      if (!state || state.path !== window.location.pathname || !Array.isArray(state.open)) return;
      qsa('.filters__group', filtersForm).forEach(function (group) {
        group.open = state.open.indexOf(groupName(group)) > -1;
      });
    };

    var restoreFieldFocus = function () {
      var state = readStore(LAST_FIELD_KEY);
      if (!state || state.path !== window.location.pathname) return;
      /* Engångsbruk: annars stjäl en gammal ruta fokus vid nästa vanliga
         besök på samma kategori. */
      writeStore(LAST_FIELD_KEY, null);

      /* Jämförs som värden i stället för att byggas in i en attributselektor —
         filternamnen kommer från Shopify och innehåller punkter och hakparenteser. */
      var field = qsa('input', filtersForm).filter(function (input) {
        return input.name === state.name && input.value === state.value;
      })[0];
      /* offsetParent är null när mobilpanelen är stängd — då finns rutan inte
         på skärmen och fokus där vore ett osynligt hopp. */
      if (field && field.offsetParent !== null) field.focus();
    };

    var submitFilters = function () {
      saveGroups();
      if (filtersForm.requestSubmit) {
        filtersForm.requestSubmit();
      } else {
        filtersForm.submit();
      }
    };

    /* --------------------------------------------------------------------
       Levande träffräknare i mobilöverlägget.

       Auto-submit är rätt i sidokolumnen på desktop: kryssrutan ÄR
       tillämpningen, och resultatet syns bredvid. I ett fullskärmsöverlägg är
       det fel — där kryssar besökaren tre rutor och trycker "Visa N produkter"
       en gång. Sorteringen är fortfarande ett avslutat beslut och postar
       direkt, precis som desktopens select.

       Siffran hämtas med Section Rendering API, samma anrop som "Visa fler"
       redan använder, och läses ur `data-result-count` som båda sektionerna
       renderar. Faller anropet ändå kvar knappen med serverns utgångstext —
       den är aldrig tom och aldrig fel om ingenting ändrats.
       -------------------------------------------------------------------- */

    var submitButton = qs('[data-filters-submit]');
    var resetButton = qs('[data-filters-reset]');
    var countTimer = null;
    var countToken = 0;

    var priceState = function () {
      return qsa('.filters__price input', filtersForm)
        .map(function (input) {
          return input.name + '=' + input.value.trim();
        })
        .join('&');
    };
    var appliedPriceState = priceState();

    var overlayOpen = function () {
      return panel && panel.classList.contains('is-open') && panel.getAttribute('data-mode') === 'filter';
    };

    var applyCountLabel = function (count) {
      if (!submitButton) return;
      var template =
        count === 0
          ? submitButton.getAttribute('data-label-zero')
          : count === 1
            ? submitButton.getAttribute('data-label-one')
            : submitButton.getAttribute('data-label-many');
      /* Saknas mallattributet skulle String(null) skriva ut ordet "null" i
         knappen. Serverns egen utgångstext duger då — den är aldrig fel, bara
         inte uppdaterad. */
      if (template) submitButton.textContent = template.replace('{n}', count);
      /* Noll träffar är en återvändsgränd: knappen tar dig till en tom sida
         som du måste backa ur. "Rensa" i huvudet är vägen ut. */
      submitButton.disabled = count === 0;
    };

    var hasPendingFilters = function () {
      var checked = qsa('input[type="checkbox"]', filtersForm).some(function (input) {
        return input.checked;
      });
      var priceEntered = qsa('.filters__price input', filtersForm).some(function (input) {
        return input.value.trim() !== '';
      });
      return checked || priceEntered;
    };

    var syncResetButton = function () {
      if (resetButton) resetButton.disabled = !hasPendingFilters();
    };

    var refreshCount = function () {
      if (!submitButton) return;
      var params = new URLSearchParams(new FormData(filtersForm));
      var url = filtersForm.getAttribute('action') + '?' + params.toString();
      var token = ++countToken;

      submitButton.setAttribute('aria-busy', 'true');
      fetch(url)
        .then(function (response) {
          return response.ok ? response.text() : null;
        })
        .then(function (html) {
          /* En långsammare tidigare begäran får inte skriva över en nyare. */
          if (token !== countToken || !html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var marker = doc.querySelector('[data-result-count]');
          if (!marker) return;
          var count = parseInt(marker.getAttribute('data-result-count'), 10);
          if (!isNaN(count)) applyCountLabel(count);
        })
        .catch(function () {
          /* Tyst: knappen behåller serverns text och fungerar ändå. */
        })
        .finally(function () {
          if (token === countToken) submitButton.removeAttribute('aria-busy');
        });
    };

    filtersForm.addEventListener('change', function (event) {
      var target = event.target;
      if (!target.matches('input[type="checkbox"], input[type="radio"]')) return;

      writeStore(LAST_FIELD_KEY, {
        path: window.location.pathname,
        name: target.name,
        value: target.value,
      });

      syncResetButton();

      if (overlayOpen() && target.type === 'checkbox') {
        window.clearTimeout(countTimer);
        countTimer = window.setTimeout(refreshCount, 300);
        return;
      }

      /* Sorteringen postar direkt. Fördröjningen finns för att den som kryssar
         tre rutor ska få en sidladdning i stället för tre — men sorteringen är
         ett enda avslutat val, och en radio kan bara ha ett värde åt gången.
         Den låg i ett eget formulär med direkt submit till 2026-08-06, och ska
         inte kännas trögare för att den flyttade in i filterkolumnen. */
      window.clearTimeout(submitTimer);
      if (target.type === 'radio' && target.name === 'sort_by') {
        submitFilters();
        return;
      }
      submitTimer = window.setTimeout(submitFilters, SUBMIT_DELAY);
    });

    /* Prisfälten är textfält och går därför inte genom change-lyssnaren ovan.
       Mobilens fasta träffknapp och Rensa alla ska ändå följa det som skrivs,
       med samma debounce som kryssrutorna för att undvika ett anrop per tecken. */
    filtersForm.addEventListener('input', function (event) {
      if (!event.target.closest('.filters__price')) return;
      syncResetButton();
      if (!overlayOpen()) return;
      window.clearTimeout(countTimer);
      countTimer = window.setTimeout(refreshCount, 300);
    });

    /* Desktop har ingen tillämpningsknapp i JS-läget, precis som IKEA.
       Vänta tills fokus lämnar HELA prisgruppen så att Tab från min till max
       inte laddar om sidan mitt mellan de två fälten. Enter går genom
       formulärets vanliga submit och fungerar fortfarande direkt. */
    filtersForm.addEventListener('focusout', function (event) {
      if (!event.target.closest('.filters__price') || overlayOpen()) return;
      window.clearTimeout(submitTimer);
      submitTimer = window.setTimeout(function () {
        var focused = document.activeElement;
        if (focused && focused.closest && focused.closest('.filters__price')) return;

        var nextPriceState = priceState();
        if (nextPriceState === appliedPriceState) return;
        appliedPriceState = nextPriceState;
        submitFilters();
      }, 0);
    });

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        qsa('input[type="checkbox"]', filtersForm).forEach(function (input) {
          input.checked = false;
        });
        qsa('.filters__price input', filtersForm).forEach(function (input) {
          input.value = '';
        });
        qsa('.filters__summary-count', filtersForm).forEach(function (count) {
          count.remove();
        });
        syncResetButton();
        refreshCount();
      });
    }

    /* "Visa resultat", Enter i prisfältet eller en submit medan fördröjningen
       löper — samma tillstånd ska följa med oavsett vilken väg som tog dit. */
    filtersForm.addEventListener('submit', function () {
      window.clearTimeout(submitTimer);
      saveGroups();
    });

    restoreGroups();
    restoreFieldFocus();
    syncResetButton();
  }

  /* --------------------------------------------------------------------
     Load more — fetch the next page via the Section Rendering API and
     append its products, instead of navigating away.

     Taket är tre klick, alltså tre sidor utöver den första. Ett rutnät som
     bara växer blir en sida ingen kan navigera i, och skrollpositionen går
     förlorad så fort besökaren följer en produktlänk och backar. Därefter tar
     pagineringen vid — den är redan renderad i sidan (se
     sections/main-collection.liquid), inte något som byggs här.
     -------------------------------------------------------------------- */

  var LOAD_MORE_MAX = 3;
  var loadedBatches = 0;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-load-more]');
    if (!trigger) return;

    var sectionId = trigger.dataset.sectionId;
    var nextUrl = trigger.dataset.nextUrl || trigger.getAttribute('href');
    if (!sectionId || !nextUrl) return;

    event.preventDefault();

    /* A batch fetch is already in flight for this trigger — a second click
       before it resolves would append the same batch twice. */
    if (trigger.getAttribute('aria-busy') === 'true') return;
    trigger.setAttribute('aria-busy', 'true');

    var wasFocused = document.activeElement === trigger;

    var separator = nextUrl.indexOf('?') > -1 ? '&' : '?';
    var fetchUrl = nextUrl + separator + 'section_id=' + encodeURIComponent(sectionId);

    fetch(fetchUrl)
      .then(function (response) {
        /* Utan den här kollen blir en 404, ett 500-svar eller en mellansida
           från brandväggen till "en sida utan produkter": knappen togs bort,
           sidnavigeringen låstes kvar som dold, statusraden sa "0 produkter
           till visas" och adressfältet skrevs om till ?page=2 — besökaren stod
           kvar på sida 1 utan väg vidare och med en URL som ljög. Ett kastat
           fel går i stället till .catch nedan, som navigerar till nästa sida
           på riktigt. */
        if (!response.ok) throw new Error('load more: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var freshGrid = doc.querySelector('.product-grid');
        /* 200 men ingen produktgrid — det är inte den sektion vi bad om
           (utloggningssida, robotkontroll, ombyggd mall). Samma utväg. */
        if (!freshGrid) throw new Error('load more: ingen produktgrid i svaret');

        var currentGrid = qs('.product-grid');
        var addedCount = 0;
        if (currentGrid) {
          Array.prototype.slice.call(freshGrid.children).forEach(function (card) {
            currentGrid.appendChild(card);
            addedCount += 1;
          });
          if (window.themeSavedProducts) {
            window.themeSavedProducts.syncButtons(currentGrid);
          }
          /* Product cards carry a JS-only mobile cart controller. Tell
             cart.js about newly appended cards in the same task, before the
             browser can paint their native fallback beside existing cards. */
          document.dispatchEvent(new CustomEvent('product-cards:added', {
            detail: { root: currentGrid },
          }));
        }

        /* Sidans egen paginering gäller sida 1 så länge den ligger kvar. Efter
           en påfylld sida är det den hämtade sidans paginering som stämmer med
           adressfältet (history.replaceState nedan). */
        var freshPagination = doc.querySelector('.pagination');
        var currentPagination = qs('.pagination');
        if (freshPagination && currentPagination) {
          currentPagination.outerHTML = freshPagination.outerHTML;
        }

        loadedBatches += 1;
        var capped = loadedBatches >= LOAD_MORE_MAX;

        /* Sidnavigeringen kliver fram först vid taket. Fram till dess är
           "Visa fler" vägen framåt och siffrorna hade bara varit en andra
           kontroll för samma sak; vid taket ÄR de enda vägen vidare.
           Länkarna har legat i HTML:en hela tiden — det är bara synligheten
           som skjutits upp, se .pagination--deferred i base.css.

           `toggle` och inte `remove`: markupen ovan byttes nyss mot den
           hämtade sidans, och den kommer från sida 2 eller senare och bär
           därför ingen `--deferred`. Utan att sätta tillbaka den skulle
           siffrorna dyka upp redan vid första klicket. */
        var pagination = qs('.pagination');
        if (pagination) pagination.classList.toggle('pagination--deferred', !capped);

        /* Blocket byts alltid mot den hämtade sidans — det är där räknaren
           "Visar X av Y" står, och den ska följa med. Vid taket tas bara
           knappen bort, inte hela blocket: besökaren behöver fortfarande se
           var i listan hen befinner sig, och pagineringen under tar vid. */
        var freshLoadmore = doc.querySelector('.collection-loadmore');
        var currentLoadmore = qs('.collection-loadmore');
        if (currentLoadmore) {
          if (freshLoadmore) {
            currentLoadmore.outerHTML = freshLoadmore.outerHTML;
            if (capped) {
              var cappedButton = qs('.collection-loadmore [data-load-more]');
              if (cappedButton) cappedButton.remove();
            }
          } else {
            currentLoadmore.remove();
          }
        }

        var status = qs('[data-collection-status]');
        if (status) {
          status.textContent = capped
            ? addedCount + ' produkter till visas. Fler produkter nås via sidnavigeringen.'
            : addedCount + ' produkter till visas.';
        }

        /* Knappen som hade fokus byttes eller togs bort nyss, och utan det här
           står tangentbordet på <body> längst upp i dokumentet. */
        var nextFocus = capped ? qs('.pagination') : qs('[data-load-more]');
        if (nextFocus && wasFocused) {
          if (capped) {
            nextFocus.setAttribute('tabindex', '-1');
            nextFocus.addEventListener('blur', function handler() {
              nextFocus.removeAttribute('tabindex');
              nextFocus.removeEventListener('blur', handler);
            });
          }
          nextFocus.focus();
        }

        window.history.replaceState(null, '', nextUrl);
      })
      .catch(function () {
        /* Sidan finns som en riktig, paginerad URL — den är hela no-JS-vägen
           och fungerar även när det här misslyckades. */
        window.location.href = nextUrl;
      });
  });

  /* Pilknapparna till underkategoriraden och filterraden ligger i
     assets/rail.js sedan 2026-08-06 (kväll) — startsidans kategorirad
     behövde samma sak, och browse.js laddas inte där. Båda sektionerna som
     renderar en rad inkluderar den filen. */
})();
